// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-consumer-mdx": () => import("./../../src/pages/consumer.mdx" /* webpackChunkName: "component---src-pages-consumer-mdx" */),
  "component---src-pages-extend-mdx": () => import("./../../src/pages/extend.mdx" /* webpackChunkName: "component---src-pages-extend-mdx" */),
  "component---src-pages-hook-mdx": () => import("./../../src/pages/hook.mdx" /* webpackChunkName: "component---src-pages-hook-mdx" */),
  "component---src-pages-index-tsx": () => import("./../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-provider-mdx": () => import("./../../src/pages/provider.mdx" /* webpackChunkName: "component---src-pages-provider-mdx" */),
  "component---src-pages-quick-start-tsx": () => import("./../../src/pages/quick-start.tsx" /* webpackChunkName: "component---src-pages-quick-start-tsx" */),
  "component---src-pages-troubleshoot-mdx": () => import("./../../src/pages/troubleshoot.mdx" /* webpackChunkName: "component---src-pages-troubleshoot-mdx" */)
}

